import { createRef, useEffect, ChangeEvent } from "react";
import { Grid, MenuItem } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICreateNovaParcelaBordero } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField } from "src/Pages/components";
import { FormatMoney, handleFormatPercent } from "src/shared/Utils/FormatMoney";
import { CardAlerts } from "src/Pages/components/CardAlerts/CardAlerts";
import { InfoOutlinedIcon } from "src/Pages/components/Icons/Icons";

export const FormEditarParcela = () => {
  const {
    valuesInputEditarParcelaBordero,
    setValuesInputEditarParcelaBordero,
  } = useContextContrato();

  const refOrigem = createRef<HTMLInputElement>();
  const handleFocusedID = () => refOrigem.current?.focus();

  useEffect(() => {
    handleFocusedID();
  }, []);

  const handleChange =
    (
      prop: keyof ICreateNovaParcelaBordero,
      option?: "limitNumber" | "money" | "percent"
    ) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "money") {
          setValuesInputEditarParcelaBordero({
            ...valuesInputEditarParcelaBordero!,
            [prop]: FormatMoney(event.target.value),
          });
        } else if (option === "limitNumber") {
          if (event.target.value.length <= 5) {
            setValuesInputEditarParcelaBordero({
              ...valuesInputEditarParcelaBordero!,
              [prop]: event.target.value,
            });
          }
        } else if (option === "percent") {
          if (event.target.value.length <= 7) {
            setValuesInputEditarParcelaBordero({
              ...valuesInputEditarParcelaBordero!,
              [prop]: handleFormatPercent(event.target.value),
            });
          }
        } else {
          setValuesInputEditarParcelaBordero({
            ...valuesInputEditarParcelaBordero!,
            [prop]: event.target.value,
          });
        }
      };

  return (
    <>
      {valuesInputEditarParcelaBordero && (
        <Grid container spacing={2} sx={{ marginBottom: "1.5rem" }}>
          <Grid container item spacing={2} mb={2}>
            <Grid item xs={8}>
              <AppTextField
                fullWidth
                label="Proposta"
                sxStyle={{ opacity: ".5", pointerEvents: "none", margin: 0 }}
                value={valuesInputEditarParcelaBordero?.cod_proposta}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4}>
              <AppTextField
                fullWidth
                label="Parcela *"
                inputRef={refOrigem}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={valuesInputEditarParcelaBordero.numero_parcela}
                variant="outlined"
                type="number"
                onChange={handleChange("numero_parcela")}
              />
            </Grid>
          </Grid>

          <Grid container item spacing={2} mb={2}>
            <Grid item xs={6}>
              <AppTextField
                fullWidth
                label="Vencimento *"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                type="date"
                value={valuesInputEditarParcelaBordero?.data_vencimento_parcela}
                variant="outlined"
                onChange={handleChange("data_vencimento_parcela")}
              />
            </Grid>
            <Grid item xs={6}>
              <AppTextField
                fullWidth
                label="Vidas *"
                type="number"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={valuesInputEditarParcelaBordero?.contratos_vidas}
                variant="outlined"
                onChange={handleChange("contratos_vidas")}
              />
            </Grid>
          </Grid>

          <Grid container item spacing={2} mb={2}>
            <Grid item xs={6} mb={1}>
              <AppTextField
                fullWidth
                label="Mensalidade *"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={valuesInputEditarParcelaBordero?.contratos_mensalidade}
                variant="outlined"
                onChange={handleChange("contratos_mensalidade", "money")}
              />
            </Grid>

            <Grid container item spacing={1}>
              <Grid item sm={3} xs={6}>
                <AppTextField
                  fullWidth
                  label="% Corretora *"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={
                    valuesInputEditarParcelaBordero?.porcentagem_comissao_corretora
                  }
                  variant="outlined"
                  onChange={handleChange(
                    "porcentagem_comissao_corretora",
                    "percent"
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={6}>
                <AppTextField
                  fullWidth
                  label="% Corretor *"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={
                    valuesInputEditarParcelaBordero?.porcentagem_comissao_corretor
                  }
                  variant="outlined"
                  onChange={handleChange(
                    "porcentagem_comissao_corretor",
                    "percent"
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={6}>
                <AppTextField
                  fullWidth
                  label="% Supervisor"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={
                    valuesInputEditarParcelaBordero?.porcentagem_comissao_supervisor
                  }
                  variant="outlined"
                  onChange={handleChange(
                    "porcentagem_comissao_supervisor",
                    "percent"
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={6}>
                <AppTextField
                  fullWidth
                  label="% Gerente"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={
                    valuesInputEditarParcelaBordero?.porcentagem_comissao_gerente
                  }
                  variant="outlined"
                  onChange={handleChange(
                    "porcentagem_comissao_gerente",
                    "percent"
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Vitalício */}
          <Grid container item spacing={1}>
            <Grid item xs={3}>
              <AppTextField
                fullWidth
                label="Vitalício Corretora"
                variant="outlined"
                select
                value={valuesInputEditarParcelaBordero?.is_vitalicio_corretora}
                onChange={handleChange("is_vitalicio_corretora")}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
              >
                <MenuItem value="TRUE">Sim</MenuItem>
                <MenuItem value="FALSE">Não</MenuItem>
              </AppTextField>
            </Grid>
            <Grid item xs={3}>
              <AppTextField
                fullWidth
                label="Vitalício Corretor"
                variant="outlined"
                select
                value={valuesInputEditarParcelaBordero?.is_vitalicio_corretor}
                onChange={handleChange("is_vitalicio_corretor")}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
              >
                <MenuItem value="TRUE">Sim</MenuItem>
                <MenuItem value="FALSE">Não</MenuItem>
              </AppTextField>
            </Grid>
            <Grid item xs={3}>
              <AppTextField
                fullWidth
                label="Vitalício Supervisor"
                variant="outlined"
                select
                value={valuesInputEditarParcelaBordero?.is_vitalicio_supervisor}
                onChange={handleChange("is_vitalicio_supervisor")}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
              >
                <MenuItem value="TRUE">Sim</MenuItem>
                <MenuItem value="FALSE">Não</MenuItem>
              </AppTextField>
            </Grid>
            <Grid item xs={3}>
              <AppTextField
                fullWidth
                label="Vitalício Gerente"
                select
                variant="outlined"
                value={valuesInputEditarParcelaBordero?.is_vitalicio_gerente}
                onChange={handleChange("is_vitalicio_gerente")}
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
              >
                <MenuItem value="TRUE">Sim</MenuItem>
                <MenuItem value="FALSE">Não</MenuItem>
              </AppTextField>
            </Grid>
          </Grid>
        </Grid>
      )}

      {valuesInputEditarParcelaBordero && String(valuesInputEditarParcelaBordero?.numero_parcela) === "0" && (
        < CardAlerts
          title="Parcela numero 0 é considerada como parcela de adesão !"
          subTitle="Ela é uma parcela normal - Todas as ações estão habilitadas, incluindo edição e geração de comissão !"
          color="primary"
          icon={<InfoOutlinedIcon fontSize="small" />}
        />
      )}
    </>
  );
};
